import authRoutes from './route';

export default authRoutes;